exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".i-link {\n  cursor: pointer;\n}\n.i-link-color,\n.i-link-color:hover,\n.i-link-color:active {\n  color: inherit;\n}\n", ""]);

// exports
